export default __webpack_public_path__ + "static/media/resources_mobile_banner.3c03ea8c.png";